import React, { memo, useEffect } from "react";
import useScrollTop from "./index.hooks";

type ScrollTopProps = {
  children: React.ReactElement;
};

const ScrollTop = ({ children }: ScrollTopProps) => {
  const { styles, classes, atomicStyles, location } = useScrollTop();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location]);

  return <>{children}</>;
};

export default memo(ScrollTop);
